ID.bodyProducts && addEventListener("DOMContentLoaded", _=>
document.querySelectorAll(".product .tabs > input").forEach(input => {
    let breaker = parseInt(FN.getCSSVar(document.body, "--break-sm-end"));
    if(document.body.offsetWidth < breaker) input.checked = false;

    input.onclick = _=> {
        if(input == window.productInputActive) {
            input.checked = false;
            window.productInputActive = undefined;
        }
        else window.productInputActive = input;
    }
}));

// umístění dostupnosti
FNP.products.placeAvailability = _=>
    (_=ID["snippet--productInfo"]) &&
    (_.style.top=-document.querySelector('.form-row.amount').offsetHeight-40+'px');

ID.bodyProducts && addEventListener("load", FNP.products.placeAvailability);
ID.bodyProducts && addEventListener("resize", FNP.products.placeAvailability);

document.addEventListener('DOMContentLoaded', () => {
    try {
        const modal = document.getElementById('modalProduct');
        const openButton = document.getElementById('openModalProduct');
        const modalContentProductCloseButton = document.getElementById('modalContentProductClose');

        // Otevření modálního okna
        openButton.addEventListener('click', () => {
            modal.style.display = 'block';
        });

        modalContentProductCloseButton.addEventListener('click', () => {
            modal.style.display = 'none';
        });

        // Zavření modálního okna při kliknutí mimo obsah
        window.addEventListener('click', (event) => {
            if (event.target === modal) {
                modal.style.display = 'none';
            }
        }); 
    } catch (e) {
         
    }           
}); 

document.addEventListener('DOMContentLoaded', () => {
    const tabsDiv = document.querySelector('.tabs');
    const validTexts = ["Velikostní tabulka", "Size chart", "Veľkostná tabuľka"]; // Definice přesunuta mimo všechny funkce

    if (tabsDiv) {
        const label = Array.from(tabsDiv.querySelectorAll('label')).find(label => {
            const span = label.querySelector('span');
            const u = label.querySelector('u');
            return span && validTexts.includes(span.textContent.trim()) && u?.textContent.trim() === "chevron1";
        });

        if (label) {

            const sizesDiv = document.querySelector('div[data-toggle="buttons"].sizes');
            if (sizesDiv) {
                const language = document.documentElement.lang || "cs"; 
                let displayText = "Velikostní tabulka"; 

                if (language.startsWith("en")) {
                    displayText = "Size chart";
                } else if (language.startsWith("sk")) {
                    displayText = "Veľkostná tabuľka";
                }

                const newDiv = document.createElement('div');
                newDiv.className = 'SizeChartDiv';
                newDiv.style.display = 'flex';
                newDiv.style.alignItems = 'center';
                newDiv.style.position = 'relative';
                newDiv.style.clear = 'both';
                newDiv.style.cursor = 'pointer';

                const icon = document.createElement('img');
                icon.src = '/assets/img/icon-measure.png'; 
                icon.alt = 'Icon';
                icon.style.marginRight = '8px';
                icon.style.width = '24px'; 
                icon.style.height = '24px';

                const textNode = document.createElement('span');
                textNode.textContent = displayText;

                newDiv.appendChild(icon);
                newDiv.appendChild(textNode);

                sizesDiv.appendChild(newDiv);

                newDiv.addEventListener('click', () => {
                    const tab = Array.from(tabsDiv.querySelectorAll('label')).find(label => {
                        const span = label.querySelector('span');
                        return span && validTexts.includes(span.textContent.trim()); // validTexts použita zde
                    });

                    if (tab) {
                        const isTabChecked = tab.previousElementSibling?.checked;

                        if (!isTabChecked) { 
                            tab.scrollIntoView({ behavior: 'smooth', block: 'start' });
                            tab.click();
                        } else {
                            tab.scrollIntoView({ behavior: 'smooth', block: 'start' });
                        }
                    }
                });
            }
        }
    }
});
